<template>
<div class="home">
  <h1>{{msg}}</h1>
  <p>lo que buscas no está aquí..</p>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data () {
    return {
      msg: 'Error 404'
    }
  }
}
</script>
